export default "__VITE_ASSET__C12mr_fh__"